import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DisconnectedDialogComponent } from '../../components/disconnected-dialog/disconnected-dialog.component';

/**
 * Intercepts all HTTP requests and adds the access token to the header if it exists.
 * @param {HttpRequest<any>} req - the request object
 * @param {HttpHandler} next - the next handler in the chain
 * @returns {Observable<HttpEvent<any>>} - the observable of the request
 */
@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

    reconnecting = false;
    /**
     * Array of URLS that won't be getting the SSO token added into their header
     */
    private readonly publicUrls: string[] = [
      `${environment.URL_Front}`
    ]

    constructor(private authService: OAuthService, private _dialog: MatDialog) {}

    /**
     * Add the SSO token to the request if needed
     * @param req intercepted request
     * @param next http handler to call once the request is ready
     * @returns
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
            const url = req.url.toLocaleLowerCase();

            if (!this.isUrlPublic(url)) {
              const accessToken = this.authService.getAccessToken();
              const header = 'Bearer '+ accessToken;
              const headers = req.headers.set('Authorization', header);
              req = req.clone({headers});
            }

            return next.handle(req).pipe(
                catchError((err: any) => {
                    if (err instanceof HttpErrorResponse && err.status === 401) {
                      if (this.reconnecting === false) {
                        this.reconnecting = true;
                        let config: MatDialogConfig = new MatDialogConfig();
                        config.panelClass = 'gs1-default-modal';
                        config.maxWidth = '960px';
                        config.disableClose = true;
                        config.hasBackdrop = true;
                        config.closeOnNavigation = false;
                        this._dialog.open(DisconnectedDialogComponent, config);
                      }
                    }else if (err instanceof HttpErrorResponse && err.status === 415){
                      throw err;
                    }
                    return throwError(() => new Error(err))
                })
            )
    }

    /**
     * Method to check if a given url is among the publicUrls array
     * @param url url to check
     * @returns true if the url should not have the SSO token into its headers, false otherwise
     */
    isUrlPublic(url: string): boolean {
      return !!this.publicUrls.find(u => {
        return url.startsWith(u)
      })
    }

}
